import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Divider from '@mui/material/Divider';
import { Button, Typography, Box, Grid, Paper } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BusinessIcon from '@mui/icons-material/Business';

import image1 from "../../Assets/img/Image_Card.png"
import top_bg from '../../Assets/img/top_bg.png';
import logo from '../../Assets/img/logo.svg';
import image2 from '../../Assets/img/Image_Card_2.png';
import image3 from '../../Assets/img/Frame.png';
import image4 from '../../Assets/img/password.png';
import GoogleSignup from "../../Assets/img/google-su.png"
import LinkedInSignup from "../../Assets/img/linkedin-su.png"
import MicrosoftSignUp from "../../Assets/img/microsoft-su.png"
import AppleSignUp from "../../Assets/img/apple-su.png"

function PreOnboard() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showUserTypeSelection, setShowUserTypeSelection] = useState(false);
    const navigate = useNavigate();

    const title = ["Welcome to Neoin"];
    const images = [image1, image4, image3, image2];
    const headers = ["Crafting Digital Solutions", "Create your Account", "Create your Digital Card", "Connect Communicate & Engage", "Choose Your User Type"];
    const contents = ["NEOIN, a secure verified ID, safeguards global users against Deep Fake, Phishing fraud. It offers a unique ID for SMEs, Gen Z, Professionals, Banks etc.", "Join NEOIN with just a few clicks. Create your account now and unlock a world of secure, verified IDs. ", "Craft and customize your digital card effortlessly. Share your verified identity securely with NEOIN's digital cards. ", "Seamless networking and collaboration. NEOIN makes connecting and interacting effortless for a thriving community. ", "Choose your category"];

    const nextImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const handleGetStarted = () => {
        setShowUserTypeSelection(true);
    };

    const handleUserTypeSelect = (userType) => {
        if (userType === 'user') {
            navigate('/signup');
        } else if (userType === 'company') {
            const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
            window.location.replace(`${baseUrl}/onboarding`);
        }
    };

    // If we're showing user type selection, render that instead
    if (showUserTypeSelection) {
        return (
            <div className="product-container">
                <img className="header-image" src={top_bg} alt="Header" />
                <div className="onboard_header">
                    <img className="logo" src={logo} alt="Logo" />
                </div>
                <div className="content-wrapper">
                    <div className='title-container'>
                        <h1 className='title-content'>Select Your Profile Type</h1>
                    </div>

                    <div className="user-type-selection-container">
                        <Grid container spacing={4} justifyContent="center">
                            <Grid item xs={12} sm={5}>
                                <Paper
                                    className="user-type-card"
                                    elevation={3}
                                    onClick={() => handleUserTypeSelect('user')}
                                    sx={{
                                        p: 2,
                                        textAlign: 'center',
                                        cursor: 'pointer',
                                        transition: 'transform 0.3s, box-shadow 0.3s',
                                        '&:hover': {
                                            transform: 'scale(1.05)',
                                            boxShadow: 2,
                                        },
                                        borderRadius: 3,
                                        height: "250px",
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        border: "1px solid #0044C6"
                                        // backgroundColor: '#f8f9fa'
                                    }}
                                >
                                    <AccountCircleIcon
                                        sx={{
                                            fontSize: 80,
                                            color: '#0044C6',
                                            mb: 2
                                        }}
                                    />
                                    <Typography variant="h6" gutterBottom sx={{ fontSize: "18px", fontWeight: 'bold', color: '#333' }}>
                                        Individual User
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            mt: 3,
                                            backgroundColor: '#0044C6',
                                            '&:hover': {
                                                backgroundColor: '#003399'
                                            }
                                        }}
                                    >
                                        Continue
                                    </Button>
                                </Paper>
                            </Grid>

                            <Grid item xs={12} sm={5}>
                                <Paper
                                    className="user-type-card"
                                    elevation={3}
                                    onClick={() => handleUserTypeSelect('company')}
                                    sx={{
                                        p: 2,
                                        textAlign: 'center',
                                        cursor: 'pointer',
                                        transition: 'transform 0.3s, box-shadow 0.3s',
                                        '&:hover': {
                                            transform: 'scale(1.05)',
                                            boxShadow: 2,
                                        },
                                        borderRadius: 3,
                                        height: "250px",
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        // backgroundColor: '#f8f9fa'
                                        border: "1px solid #0044C6"
                                    }}
                                >
                                    <BusinessIcon
                                        sx={{
                                            fontSize: 80,
                                            color: '#0044C6',
                                            mb: 2
                                        }}
                                    />
                                    <Typography variant="h6" gutterBottom sx={{ fontSize: "18px", fontWeight: 'bold', color: '#333' }}>
                                        Company / Organization
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            mt: 3,
                                            backgroundColor: '#0044C6',
                                            '&:hover': {
                                                backgroundColor: '#003399'
                                            }
                                        }}
                                    >
                                        Continue
                                    </Button>
                                </Paper>
                            </Grid>
                        </Grid>

                        <Box sx={{ mt: 4, textAlign: 'center' }}>
                            <Typography variant="body2" sx={{ color: '#666' }}>
                                Already have an account? <Link to="/login" style={{ color: '#0044C6', textDecoration: 'none' }}>Login here</Link>
                            </Typography>
                        </Box>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="product-container">
            <img className="header-image" src={top_bg} alt="Header" />
            <div className="onboard_header">
                <img className="logo" src={logo} alt="Logo" />
            </div>
            <div className="content-wrapper">
                {(currentIndex !== 0) ? (
                    <div className='title-container'>
                        <h1 className='title-content'>{title[currentIndex]}</h1>
                    </div>
                ) : (
                    <div className='title-container-first-image'>
                        <h1 className='title-content'>{title[currentIndex]}</h1>
                    </div>
                )}

                <div className="scrollable-images-container">
                    {(currentIndex !== 0) ? (
                        <div className="onboard-image-container">
                            <img className="scrollable-image" src={images[currentIndex]} alt={`Image ${currentIndex + 1}`} />
                            <div className="product-content">
                                <h2 className="onboard_header_align">{headers[currentIndex]}</h2>
                                <p className="paragraph-text">{contents[currentIndex]}</p>
                            </div>
                        </div>
                    ) : (
                        <div className="onboard-image-container-first-image">
                            <img className="scrollable-image" src={images[currentIndex]} alt={`Image ${currentIndex + 1}`} />
                            <div className="product-content">
                                <h2 className="onboard_header_align">{headers[currentIndex]}</h2>
                                <p className="paragraph-text">{contents[currentIndex]}</p>
                            </div>
                        </div>
                    )}


                    <div className="dots">
                        {images?.map((_, index) => (
                            <span key={index} className={`dot ${currentIndex === index ? 'active' : ''}`}></span>
                        ))}
                    </div>


                    {currentIndex !== images?.length - 1 ? (
                        <div className="controls">
                            <Link to="#" className='Link-black-text'>
                                <Button
                                    variant='outlined'
                                    className="skip-btn priority"
                                    onClick={() => setShowUserTypeSelection(true)} // Changed this
                                >
                                    SKIP
                                </Button>
                            </Link>
                            <Button className="next-btn ms-3" sx={{ color: "#0044C6" }} variant='outlined' onClick={nextImage}>NEXT</Button>
                            {currentIndex === 0 && (
                                <div className='sign-up-options'>
                                    <Typography>Already have a account ? <a href='/login'>login</a></Typography>
                                </div>
                            )}

                        </div>



                    ) : (<div className='sign-up-options-1'>
                        <Button
                            variant='outlined'
                            className="primary-outlined get-started-btn"
                            onClick={handleGetStarted}
                        >
                            GET STARTED
                        </Button> <br />
                    </div>)}

                </div>
            </div>
        </div>
    );
}

export default PreOnboard;